import cookies from 'js-cookie';
import { memo } from 'react';
import { LogOut } from 'lucide-react';

import { cookieNames, UserBadgePanel } from '@monorepo/common';

import { cn } from '@/lib/utils';
import BurgerMenu from '../BurgerMenu';
import IconLogo from '../Icons/IconLogo';

import { hostNames } from '@/constants/hosts';
import { useAppSelector } from '@/store/hooks';
import { useGetPublicProfile } from '@/hooks/use-user-profile';

const Header = () => {
  const { showLeftSide, isAuth } = useAppSelector(({ ui, auth }) => ({
    showLeftSide: ui.showLeftSide,
    isAuth: auth.isAuth
  }));
  const { data: userData } = useGetPublicProfile(isAuth);

  const logOut = () => {
    cookies.remove(cookieNames.bevnet_token);
    cookies.remove(cookieNames.refresh_token);
    if (process.env.NODE_ENV === 'production') {
      window.location.href = 'https://auth.cpgmedia.com/logout?returnUrl=https://account.bevnet.com/';
      return;
    }
    window.location.reload();
  };

  return (
    <header
      className={cn(
        'sticky top-0 right-0 z-50 bg-white transition-[padding-left] duration-400',
        !showLeftSide && 'pl-20'
      )}
    >
      <div className="flex items-center min-h-16 px-4">
        <BurgerMenu />
        <IconLogo
          numberHost={hostNames[window.location.host.replace('account.', '')]}
        />
        <h5 className="text-[1.0625rem] font-semibold leading-relaxed text-black">
          User Portal
        </h5>

        {isAuth && (
          // @ts-ignore - React 17 type compatibility issue with @monorepo/common
          <UserBadgePanel
            headshot={userData?.headshot}
            menuList={[
              {
                title: 'Log Out',
                icon: <LogOut className="h-4 w-4" />,
                handlerClick: logOut
              }
            ]}
          />
        )}
      </div>
    </header>
  );
};

export default memo(Header);
